__turbopack_context__.v({
  "linkButton": "LinkButton-module__0MMgLG__linkButton",
});
